import { canMailingTo } from 'app/common/ui-next/_filter-compilations/mailing'
import { ReportType } from 'app/dataTypes/reports'
import { OrderByClassesDetailsGroup } from 'app/dataTypes/reports/data/common/ordersByClasses'
import { OrderByClassesFilterKey as FilterKey } from 'app/components/Reports/_OrdersByClasses/filters/filterItems/types'

import { apiStringFromReportType } from '../../../data/_predefined/api-string-from-report-type'

export type ApiOrdersByClassesParams = {
  report_type: string
  params: {
    details: boolean
    details_group?:
    | 'by_classes'
    | 'by_funds'
    | 'by_customers_and_funds'
    | 'by_complexes_and_allowances'
    date: string
    from_date: string
    to_date: string
    limits: {
      school_id: number[]
      school_type: string[]
    }
  }
  signers?: {
    food_responsible_id: number
    cafeteria_manager_id: number
    accountant_id: number
  }
  options?: {
    send_to_email?: string // отправить на почту
  }
}

const getFormDataFromSelector = (formItem: string, formData: FormData) => {
  const value = formData.getAll(formItem) as Array<string> | undefined
  if (value && value.length) return value
  return []
}

export const convertParams = (formData: FormData): [ApiOrdersByClassesParams, null] => {
  const orgIDs = getFormDataFromSelector(FilterKey.Org, formData)
  const buildingIds = getFormDataFromSelector(FilterKey.Building, formData)
  const orgType = formData.get(FilterKey.OrgType) as string
  const details = formData.get(FilterKey.Details)
  const groupBy = formData.get(FilterKey.GroupBy) as OrderByClassesDetailsGroup
  const date = formData.get(FilterKey.Date) as string
  const periodFrom = formData.get(`${FilterKey.Period}From`) as string
  const periodTo = formData.get(`${FilterKey.Period}To`) as string
  const foodResponsibleId = formData.get(FilterKey.FoodResponsibleSignatory) as string
  const cafeteriaManagerId = formData.get(FilterKey.CafeteriaManagerSignatory) as string
  const accountantId = formData.get(FilterKey.AccountantSignatory) as string
  const email = canMailingTo(formData)
  const options = email ? { send_to_email: email } : {}
  return [
    {
      report_type: apiStringFromReportType(ReportType.OrdersByClasses),
      params: {
        details: !!details,
        details_group: groupBy,
        date,
        from_date: periodFrom,
        to_date: periodTo,
        limits: {
          school_id: orgIDs.map((id) => parseInt(id, 10)),
          school_type: orgType ? [orgType as string] : [],
          ...(groupBy === OrderByClassesDetailsGroup.ByComplexesAndAllowances && buildingIds[0]
            ? { building_id: parseInt(buildingIds[0], 10) }
            : {}),
        },
        // prettier-ignore
        ...(groupBy === OrderByClassesDetailsGroup.ByComplexesAndAllowances ? {
          signers: {
            food_responsible_id: foodResponsibleId ? parseInt(foodResponsibleId, 10) : undefined,
            cafeteria_manager_id: cafeteriaManagerId ? parseInt(cafeteriaManagerId, 10) : undefined,
            accountant_id: accountantId ? parseInt(accountantId, 10) : undefined,
          },
        } : {}),
      },
      options,
    },
    null,
  ]
}
